import {
  TableContainer,
  TableBody,
  TableCell,
  Table,
  TableRow,
  Grid,
} from "@material-ui/core";
import { PencilIcon, TrashIcon } from "App/Assets";
import {
  TableHeader,
  IconButtonDatatable,
  DatatablesFooter,
  ModalDeleteConfirm,
} from "App/Component/ui";
import { instance4 } from "App/constants";
import { useDatatables } from "App/hooks";
import { formatNumber } from "App/utils/helpers";
import React, { useState, useEffect, useContext } from "react";
import { stableSort, getComparator } from "App/Component/ui/datatable/utils";
import { FormContext } from "./context/FormContext";
import moment from "moment";
import { LIST_URL_WAREHOUSE } from "utils/warehouse";
import { DataReq } from "./ui";

export const urlCreatePO = LIST_URL_WAREHOUSE.purchaseOrderLGS.add;
export const urlUpdatePO = LIST_URL_WAREHOUSE.purchaseOrderLGS.update;
export const urlGetPoById = LIST_URL_WAREHOUSE.purchaseOrderLGS.getById;

export const urlGetBarangPoById =
  LIST_URL_WAREHOUSE.purchaseOrderLGS.getBarangByPO;
export const urlChangeStatus = LIST_URL_WAREHOUSE.purchaseOrderLGS.changeStatus;

export const urlGetGudang = LIST_URL_WAREHOUSE.masterGudangLGS.getGudangUtama;

export const STATUS_OPEN_DRAFT = false;
export const STATUS_PROCESS = true;

export const STATUS_TRANSAKSI_PENGAJUAN = 1;
export const STATUS_TRANSAKSI_DISETUJUI = 2;
export const STATUS_TRANSAKSI_PENGADAAN = 3;
export const STATUS_TRANSAKSI_SELESAI = 4;

export const FORM_RESET_STATE_WMS_PO = {
  idpo: "",
  date: moment(new Date()).local().toDate(),

  gudang_id: null,
  gudang: "Pilih Gudang Logistik",

  supplier_id: null,
  supplier: "Pilih Supplier",

  penerima: "",
  remark: "",
  nomorPo: "",

  type: "create",
  status: 0,

  isOpenDraf: false,
  isProcess: false,

  is_persentase_potongan: false,
  diskon_persen: 0,
  
  jumlah: 0,
  tax: 0,
  potongan: 0,
  potongan2: 0,
  total_jumlah: 0,
  listpo: [],
  status_transaksi: 0,
  catatan_proses: "",
};

const getMasterGudangOnlyLogistik = async (url) => {
  try {
    const api = await instance4.get(url);
    const res = api.data;
    return res.body;
  } catch (error) {
    return false;
  }
};

export const getPoById = async (id) => {
  try {
    const api = await instance4.get(`${urlGetPoById}/${id}`);
    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        data:
          res.data.length > 0
            ? res.data[0]
            : {
                totalTax: 0,
                jumlah: 0,
              },
      };
    } else {
      return {
        state: false,
        message: res.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const getPoListById = async (id) => {
  try {
    const api = await instance4.get(`${urlGetBarangPoById}/${id}`);
    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        data: res.data,
      };
    } else {
      return {
        state: false,
        message: res.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

// export const deletePoListById = async (id) => {
//   try {
//     const api = await instance4.post(urlDeleteBarang, {
//       id,
//     });
//     const res = api.data;
//     if (res.status === 200) {
//       return {
//         state: true,
//         data: res,
//         message: "Berhasil menghapus po list",
//       };
//     } else {
//       return {
//         state: false,
//         message: res.message,
//       };
//     }
//   } catch (error) {
//     return {
//       state: false,
//       data: {},
//       message: error?.response?.data?.message,
//     };
//   }
// };

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "id",
    disablePadding: true,
    label: "ID",
    align: "left",
  },
  {
    id: "namabarang",
    disablePadding: false,
    label: "NAMA BARANG",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "namasatuan",
    disablePadding: false,
    label: "SATUAN",
    align: "left",
  },
  {
    id: "qty",
    disablePadding: false,
    label: "QTY",
    align: "left",
  },
  {
    id: "harga",
    disablePadding: false,
    label: "HARGA",
    align: "left",
  },
  {
    id: "disc",
    disablePadding: false,
    label: "DISC (%)",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "sub_jumlah",
    disablePadding: false,
    label: "SUB JUMLAH",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "nilai_disc",
    disablePadding: false,
    label: "NILAI DISC",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "jumlah",
    disablePadding: false,
    label: "JUMLAH",
    align: "left",
  },
];

export const useInitalGudangOnlyLogistik = (
  url = LIST_URL_WAREHOUSE.masterGudangLGS.InitialLGS
) => {
  const [state, setState] = useState([]);
  useEffect(() => {
    (async () => {
      const res = await getMasterGudangOnlyLogistik(url);
      if (res) {
        const data = [];
        res.map((item) => {
          return data.push({
            value: item.id,
            label: item.name,
          });
        });

        setState(data);
      }
    })();
  }, [url]);

  return state;
};

export const setPerhitungan = (formData, setFormData, row) => {
  return setFormData({
    ...formData,
    jumlah: row?.jumlah,
    tax: row?.tax,
    total_jumlah: row?.total_jumlah,
  });
};

export const RenderListPo = ({
  classes,
  listPO,
  formBarang,
  setFormBarang,
  showModalBarang,
  setShowModalBarang,
  setNewDataPoList,
  setListPO,
}) => {
  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false);

  const {
    page,
    setPage,
    setRowsPerPage,
    data,
    order,
    orderBy,
    handleRequestSort,
    length,
    rowsPerPage,
  } = useDatatables({
    rows: listPO,
    orderByDefault: "barang_id",
    orderByRow: ["barang_id"],
  });
  const { formData, rowsRekomendasi } = useContext(FormContext);

  async function deleteList() {
    const barang = listPO;
    const checkBarang = barang.filter(
      (e) => e.barang_id !== formBarang.barang_id
    );
    setListPO(checkBarang);
    setShowModalDeleteConfirm(false);
  }

  // const handleClickDelete = (row, listPO) => {
  //   setShowModalDeleteConfirm(!showModalDeleteConfirm);
  //   const barang = listPO;
  //   const checkBarang = barang.filter((e) => e.barang_id !== row.barang_id);
  //   setListPO({
  //     checkBarang,
  //   });
  // };

  const handleClickDelete = (row) => {
    setShowModalDeleteConfirm(!showModalDeleteConfirm);
    setFormBarang({
      ...formBarang,
      barang_id: row?.barang_id,
    });
  };

  const handleClickUpdate = async (row) => {
    await setFormBarang({
      id: row?.id,
      barang_id: row.barang_id,
      satuan_id: row.satuan_id,
      namabarang: row.namabarang,
      namasatuan: row.namasatuan,
      qty: row.qty,
      disc: row.disc,
      harga: row.harga,
      harga2: formatNumber(row.harga),
      statUpdate: true,
    });
    setShowModalBarang(!showModalBarang);
  };

  return (
    <>
      {showModalDeleteConfirm && (
        <ModalDeleteConfirm
          confirmHandle={() => deleteList()}
          setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
        />
      )}
      {rowsRekomendasi.length > 0 && (
        <Grid container spacing={2} >
          <Grid item xs={12} sm={12}>
            <DataReq />
          </Grid>
        </Grid>
      )}
      <h5 className="fw-600 mb-1 mt-2">Data Transaki PO</h5>
      <TableContainer className="custom-scrollbar">
        <Table
          className={classes.table}
          aria-labelledby="tableTitle"
          size={"medium"}
          aria-label="enhanced table"
        >
          <TableHeader
            order={order}
            orderBy={orderBy}
            onRequestSort={handleRequestSort}
            rowCount={length}
            headCells={headCells}
          />
          <TableBody>
            {stableSort(data, getComparator(order, orderBy))
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, index) => {
                return (
                  <TableRow
                    hover
                    tabIndex={-1}
                    key={index}
                    style={{
                      backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
                    }}
                  >
                    <TableCell
                      component="th"
                      scope="row"
                      padding="none"
                      align="center"
                    >
                      {index + 1}
                    </TableCell>

                    <TableCell
                      component="th"
                      scope="row"
                      padding="none"
                      align="center"
                    >
                      {!formData.isProcess && (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "7px",
                          }}
                        >
                          <IconButtonDatatable
                            onClick={() => handleClickUpdate(row)}
                          >
                            <PencilIcon />
                          </IconButtonDatatable>

                          <IconButtonDatatable
                            onClick={() => handleClickDelete(row)}
                          >
                            <TrashIcon />
                          </IconButtonDatatable>
                        </div>
                      )}
                    </TableCell>
                    <RenderTableCell row={row} />
                  </TableRow>
                );
              })}
            {listPO.length === 0 && (
              <TableRow>
                <TableCell align="center" colSpan={headCells.length}>
                  Tidak ada data
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <DatatablesFooter
        page={page}
        length={length}
        rowsPerPage={rowsPerPage}
        selectRows={[10, 20, 50, 100]}
        onPageChange={(page) => setPage(page - 1)}
        onSelectChange={(e) => setRowsPerPage(e.target.value)}
      />
    </>
  );
};

const RenderTableCell = ({ row }) => {
  const harga_x_qty = row.harga * row.qty;
  const nilaiDisc = (row.disc / 100) * harga_x_qty;
  const jumlah = harga_x_qty - nilaiDisc;
  return (
    <>
      <TableCell align="left">{row?.id}</TableCell>
      <TableCell align="left">{row?.namabarang}</TableCell>
      <TableCell align="left">{row?.namasatuan}</TableCell>
      <TableCell align="left">{row.qty}</TableCell>
      <TableCell align="left">{formatNumber(row.harga)}</TableCell>
      <TableCell align="left">{row.disc}</TableCell>
      <TableCell align="left">{formatNumber(harga_x_qty)}</TableCell>
      <TableCell align="left">{formatNumber(nilaiDisc)}</TableCell>
      <TableCell align="left">{formatNumber(jumlah)}</TableCell>
    </>
  );
};
